import Footer from "./Common/Footer";
import Header from "./Common/Header";
import React, { useEffect } from "react";
function CandidateServicesNew() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="boxed_wrapper about-page">
      <div><Header /></div>

      <div
        className="page-title-area " style={{
          padding: '35px'
          , backgroundImage: "url('assets/theame/wp-content/uploads/2022/01/download-17.jpg')", // Set the image URL
          marginTop: "77px"
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="page-title-wrapper text-center">
                <h3 className=".page-title-new">Candidate Services</h3>
                <div className="breadcrumb breadcrumb-list">
                  {/* Breadcrumb NavXT 7.3.1 */}
                  <span property="itemListElement" typeof="ListItem">
                    <a
                      property="item"
                      typeof="WebPage"
                      title="Go to Megamau."
                      href="/"
                      className="home"
                    >
                      <span property="name">Home</span>
                    </a>
                    <meta property="position" content={1} />
                  </span> <span className="dvdr">
                    <i className="far fa-angle-double-right" />
                  </span>
                  <span property="itemListElement" typeof="ListItem">
                    <a
                      property="item"
                      typeof="WebPage"
                      title="Go to Megamau."
                      href="/outsourcing"
                      className="home"
                    >
                      <span property="name">Service</span>
                    </a>
                    <meta property="position" content={1} />
                  </span>
                  <span className="dvdr">
                    <i className="far fa-angle-double-right" />
                  </span>
                  <span property="itemListElement" typeof="ListItem">
                    <span property="name" className="post post-page current-item">
                      Candidate Services
                    </span>
                    <meta property="url" content="index.html" />
                    <meta property="position" content={2} />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />

      <div
        data-elementor-type="wp-page"
        data-elementor-id={346}
        className="elementor elementor-346"
      >
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-ffe7c8d elementor-section-full_width elementor-section-height-default elementor-section-height-default"
          data-id="ffe7c8d"
          data-element_type="section"
        >
          <div className="elementor-container elementor-column-gap-no">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-1e1079c"
              data-id="1e1079c"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-7708592 elementor-widget elementor-widget-about bdevs-el about"
                  data-id={7708592}
                  data-element_type="widget"
                  data-settings='{"design_style":"style_2"}'
                  data-widget_type="about.default"
                >
                  <div className="elementor-widget-container">

                    <section className="about-area">
                      <div className="container">
                        <div className="row">

                          <div className="col-xxl-12 col-xl-12 col-lg-12">
                            <div className="mabout-right bdevs-el-content mb-45">
                              <div
                                className="section_title_wrapper mb-35 wow fadeInUp"
                                data-wow-delay="0.3s"
                              >
                                <h2 className="msection-title mb-35 bdevs-el-title">
                                  <span>Candidate</span> Services
                                </h2>
                                <div className="msubtitle">
                                  <p style={{ textAlign: 'justify' }}>

                                    At <b>JobsTrinity</b>, we are committed to providing our employees with comprehensive resources to ensure a smooth and successful integration into our team. Our <b>Employee</b> Services section offers essential documents and forms to facilitate your onboarding and employment experience.

                                  </p>
                                </div>
                              </div>
                              <div className="mabout-quality">
                                <div className="mabout">
                                  <div className="megamau-mabout-repeater h-megamau-mabout-repeater-2">
                                    <div
                                      className="mabout__single d-flex align-items-center mb-35 wow fadeInUp elementor-repeater-item-fdf9234 "
                                      data-wow-delay="0.3s"
                                    >

                                      <div className="mabout__single-text">
                                        <h5 className="mabout-title mb-15 bdevs-el-list-title">
                                          Download Essential Onboarding Documents:
                                        </h5>
                                        <p style={{ textAlign: 'justify', color: "black" }} className="bdevs-el-list-desc">
                                          <b>•	Employee Information Form:</b> Provide your personal and professional details to help us maintain accurate records.
                                          <br /><b>•	Benefits Enrollment Form:</b> Enroll in our health, dental, and retirement plans to take advantage of the benefits we offer.
                                          <br /><b>•	Direct Deposit Authorization:</b> Set up direct deposit for timely and secure salary payments.
                                          <br /><b>•	Tax Withholding Form (W-4):</b> Specify your federal income tax withholding preferences.
                                          <br /><b>•	Emergency Contact Information:</b> Provide details of whom to contact in case of an emergency.
                                        </p>
                                      </div>
                                    </div>
                                    <div
                                      className="mabout__single d-flex align-items-center mb-35 wow fadeInUp elementor-repeater-item-f03b92a "
                                      data-wow-delay="0.3s"
                                    >

                                      <div className="mabout__single-text">
                                        <h5 className="mabout-title mb-15 bdevs-el-list-title">
                                          Access Additional Employee Resources:
                                        </h5>
                                        <p style={{ textAlign: 'justify', color: "black" }}
                                          className="bdevs-el-list-desc">

                                          <br /><b>•	Employee Handbook:</b> Familiarize yourself with our company policies, culture, and expectations.
                                          <br /><b>•	Code of Conduct:</b> Understand the standards of behavior we uphold within our organization.
                                          <br /><b>•	Leave Request Form:</b> Submit requests for vacation, medical, or other types of leave.
                                          <br /><b>•	Expense Reimbursement Form:</b> Claim reimbursements for work-related expenses incurred.
                                          <br /><b>•	Performance Review Template:</b> Prepare for regular evaluations to support your professional growth.
                                        </p>
                                      </div>
                                    </div>
                                    <div
                                      className="mabout__single d-flex align-items-center mb-35 wow fadeInUp elementor-repeater-item-f03b92a "
                                      data-wow-delay="0.3s"
                                    >

                                      <div className="mabout__single-text">
                                        <h5 className="mabout-title mb-15 bdevs-el-list-title">
                                          International Employee Services – Comprehensive Support for Global Talent
                                        </h5>
                                        <p style={{ textAlign: 'justify', color: "black" }} className="bdevs-el-list-desc">
                                          International Employee Services – Comprehensive Support for Global Talent
                                          At <b>JobsTrinity</b>, we understand that relocating to a new country for work can be both exciting and challenging. That’s why we offer a <b>comprehensive suite of international employee services</b> to ensure a smooth transition and a hassle-free experience for professionals moving to India. Our support system is designed to provide <b>security, comfort, and convenience</b>, allowing you to focus on your career while we take care of the rest.

                                        </p>
                                      </div>
                                    </div>

                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                    <section className="about-area">
                      <div className="container">
                        <div className="row">

                          <div className="col-xxl-12 col-xl-12 col-lg-12">
                            <div className="mabout-right bdevs-el-content mb-45">
                              <div
                                className="section_title_wrapper mb-35 wow fadeInUp"
                                data-wow-delay="0.3s"
                              >
                                <h2 className="msection-title mb-35 bdevs-el-title">
                                  Our<span> International</span> Employee Services Include
                                </h2>

                              </div>
                              <div className="mabout-quality">
                                <div className="mabout">
                                  <div className="megamau-mabout-repeater h-megamau-mabout-repeater-2">
                                    <div
                                      className="mabout__single d-flex align-items-center mb-35 wow fadeInUp elementor-repeater-item-f03b92a "
                                      data-wow-delay="0.3s"
                                    >

                                      <div className="mabout__single-text">
                                        <h5 className="mabout-title mb-15 bdevs-el-list-title">
                                          Visa Consultation & Immigration Assistance
                                        </h5>
                                        <p style={{ textAlign: 'justify', color: "black" }} className="bdevs-el-list-desc">
                                          Navigating visa and immigration processes can be complex, but our dedicated visa consultants are here to help. We provide - Guidance on work permits and visa applications, Assistance with documentation and approvals and also Support for visa extensions and renewals

                                        </p>
                                      </div>
                                    </div>

                                    <div
                                      className="mabout__single d-flex align-items-center mb-35 wow fadeInUp elementor-repeater-item-f03b92a "
                                      data-wow-delay="0.3s"
                                    >

                                      <div className="mabout__single-text">
                                        <h5 className="mabout-title mb-15 bdevs-el-list-title">
                                          Free Health Checkups in India
                                        </h5>
                                        <p style={{ textAlign: 'justify', color: "black" }} className="bdevs-el-list-desc">
                                          Your well-being is our priority. All international employees receive a <b>comprehensive health checkup</b> upon arrival in India at our partner medical facilities. Our health services include General health screening to ensure fitness for work and preventive care for a healthy start in your new role

                                        </p>
                                      </div>
                                    </div>
                                    <div
                                      className="mabout__single d-flex align-items-center mb-35 wow fadeInUp elementor-repeater-item-f03b92a "
                                      data-wow-delay="0.3s"
                                    >

                                      <div className="mabout__single-text">
                                        <h5 className="mabout-title mb-15 bdevs-el-list-title">
                                          Family Care & Relocation Assistance
                                        </h5>
                                        <p style={{ textAlign: 'justify', color: "black" }} className="bdevs-el-list-desc">
                                          We understand the importance of family support when moving abroad. To make your transition easier, we offer full and extended assistance for your family transit.

                                        </p>
                                      </div>
                                    </div>
                                    <div
                                      className="mabout__single d-flex align-items-center mb-35 wow fadeInUp elementor-repeater-item-f03b92a "
                                      data-wow-delay="0.3s"
                                    >

                                      <div className="mabout__single-text">
                                        <h5 className="mabout-title mb-15 bdevs-el-list-title">
                                          One-Month Paid Accommodation
                                        </h5>
                                        <p style={{ textAlign: 'justify', color: "black" }} className="bdevs-el-list-desc">
                                          To ensure a stress-free relocation, JobsTrinity provides one month of fully paid accommodation for all international employees. Our housing benefits include:

                                        </p>
                                      </div>
                                    </div>
                                    <div
                                      className="mabout__single d-flex align-items-center mb-35 wow fadeInUp elementor-repeater-item-f03b92a "
                                      data-wow-delay="0.3s"
                                    >

                                      <div className="mabout__single-text">
                                        <h5 className="mabout-title mb-15 bdevs-el-list-title">
                                          Free Insurance Support for the First Year
                                        </h5>
                                        <p style={{ textAlign: 'justify', color: "black" }} className="bdevs-el-list-desc">
                                          Your safety and security matter to us. That’s why we offer <b>complimentary insurance coverage</b> for your first year in India, which includes: Health insurance, Accident insurance, Life insurance to provide peace of mind for you and your family
                                          <br />
                                          <br />
                                          We encourage all employees to download and review these documents to ensure a seamless onboarding process and a clear understanding of our organizational practices. Should you have any questions or require assistance, please do not hesitate to contact our Human Resources department at HR@jobstrinity.com.
                                          <br />
                                          <br />
                                          <b>Welcome to JobsTrinity-</b> we are excited to have you as part of our dynamic team!

                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      </div>

      <div><Footer /></div>
    </div>

  );
}
export default CandidateServicesNew;
